var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "el-dialog",
    {
      attrs: {
        title: `Modificar conector AWS S3`,
        visible: _vm.showing,
        width: "35rem",
      },
      on: {
        "update:visible": function ($event) {
          _vm.showing = $event
        },
      },
    },
    [
      _c("S3Connector-Form", {
        ref: "form",
        attrs: { loading: _vm.loading, isEditor: "" },
        on: { submit: _vm.onSubmit },
        model: {
          value: _vm.s3Connector,
          callback: function ($$v) {
            _vm.s3Connector = $$v
          },
          expression: "s3Connector",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }